<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br>
<div class="container-xxl">
  <div class="row pt-4 pb5">
    <div class="col-2 d-flex justify-content-center neg-margin">
      <!--<app-st-profile-picture></app-st-profile-picture>-->
    </div>
    <div class="col-8">
      <app-st-header-title [inputVal]="'Your Saved Searches'"></app-st-header-title>
    </div>
  </div>
  <br>
  <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
    <app-st-span [inputVal]="'An error has occurred: '"></app-st-span>
    <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="this.showPageSuccessMessages" class="container st-form text-success" #goUp>
    <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>

  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Cancel'" [primary]="false"
                            (click)="this.onCancel()"></app-st-button-cancel>
      <app-st-button *ngIf="(this.username && this.impersonatedEmail == null) || (this.impersonatedEmail != null && this.consultantRoleName == 'COLLABORATIVE_ACCESS')"
        [idVal]="'top-save-button-id'" [label]="'Add Saved Search'" [primary]="true"
                     (click)="this.onAddSavedSearches()"></app-st-button>
    </div>
    <br>
    <br>
    <div class="tab webtext-black">
      <button *ngIf="donorTabButtonFlag" class="tabButtonActive" (click)="openSearchTypeList(event, 'DONOR_SEARCH', 'donor')">Donors</button>
      <button *ngIf="!donorTabButtonFlag" class="tabButtonInactive" (click)="openSearchTypeList(event, 'DONOR_SEARCH', 'donor')">Donors</button>
      <button *ngIf="grantTabButtonFlag" class="tabButtonActive" (click)="openSearchTypeList(event, 'GRANT_SEARCH', 'grant')">Grants</button>
      <button *ngIf="!grantTabButtonFlag" class="tabButtonInactive" (click)="openSearchTypeList(event, 'GRANT_SEARCH', 'grant')">Grants</button>
      <button *ngIf="nonprofitTabButtonFlag" class="tabButtonActive" (click)="openSearchTypeList(event, 'NONPROFIT_SEARCH', 'nonprofit')">Nonprofits</button>
      <button *ngIf="!nonprofitTabButtonFlag" class="tabButtonInactive" (click)="openSearchTypeList(event, 'NONPROFIT_SEARCH', 'nonprofit')">Nonprofits</button>
    </div>

    <div id="DONOR_SEARCH" class="tabcontent">
      <br>
      <app-st-header-title>Search Donors Saved Searches</app-st-header-title>
      <app-st-pagination2 [idVal]="'saved-search-donor-pagination-id'" [collectionSize]="this.donor_collectionSize"
                          [currentPage]="this.donor_page" [pageSize]="5" [maxPagesDisplayed]="9"
                          [customPageSizes]="this.customPageSizes"
                          (pageChange)="changePageResults($event)" #savedsearchdonorspaginator
      ></app-st-pagination2>
      <app-saved-searches-listing [savedSearches]="savedSearches"
          [searchTypeName]="this.searchTypeName"  [searchTypeRoute]="this.searchTypeRoute" >

      </app-saved-searches-listing>
    </div>

    <div id="GRANT_SEARCH" class="tabcontent">
      <br>
      <app-st-header-title>Search Grants Saved Searches</app-st-header-title>
      <app-st-pagination2 [idVal]="'saved-search-grant-pagination-id'" [collectionSize]="this.grant_collectionSize"
                          [currentPage]="this.grant_page" [pageSize]="5" [maxPagesDisplayed]="9"
                          [customPageSizes]="this.customPageSizes"
                          (pageChange)="changePageResults($event)" #savedsearchgrantspaginator
      ></app-st-pagination2>
      <app-saved-searches-listing [savedSearches]="savedSearches"
          [searchTypeName]="this.searchTypeName" [searchTypeRoute]="this.searchTypeRoute">

      </app-saved-searches-listing>
    </div>

    <div id="NONPROFIT_SEARCH" class="tabcontent">
      <br>
      <app-st-header-title>Search Nonprofits Saved Searches</app-st-header-title>
      <app-st-pagination2 [idVal]="'saved-search-nonprofit-pagination-id'" [collectionSize]="this.grant_collectionSize"
                          [currentPage]="this.grant_page" [pageSize]="5" [maxPagesDisplayed]="9"
                          [customPageSizes]="this.customPageSizes"
                          (pageChange)="changePageResults($event)" #savedsearchnonprofitspaginator
      ></app-st-pagination2>
      <app-saved-searches-listing [savedSearches]="savedSearches"
          [searchTypeName]="this.searchTypeName" [searchTypeRoute]="this.searchTypeRoute">

      </app-saved-searches-listing>
    </div>
  </div>
</div>
<br>
<br>
